<template>
  <div>
    <tci-service-head :title="title" :subtitle="subtitle">
      <div v-for="(image,index) in images" :key="image.title">
        <v-row v-if="infos&&infos[index].title">
          <v-card flat color="transparent" class="mx-auto mt-2 mb-6 text-center">
            <v-card-title class="font-weight-regular mb-2">{{ infos[index].title }}</v-card-title>
          </v-card>
        </v-row>
        <v-row v-if="image.imageUrl">
          <v-spacer></v-spacer>
          <v-img v-if="image.imageUrl" :max-width='isMobile?350:700' :src='image.imageUrl'></v-img>
          <v-spacer></v-spacer>
        </v-row>
      </div>
    </tci-service-head>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciServiceHead from "./TciServiceHead.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "TciSolution",
  props: {
    title: String,
    subtitle: String,
    content: String,
    infos: Array,
    images: Array
  },
  data: () => ({
    isMobile:false
  }),
  components: {
    "tci-service-head": TciServiceHead,
    "tci-contact-footer": TciContactFooter
  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
